module.exports = __webpack_public_path__ + "static/img/nav3.0db8435.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav3.jpg
// module id = wFnf
// module chunks = 31